import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { 
  TIMER_SHOW_MSG_MODAL_IN_APP_LOGGED_USERS, 
  TIMER_SHOW_MSG_MODAL_IN_APP_ANONYMOUS_USERS 
} from '../../../constants';
import { 
  isContainerTelcelSelector
} from '../../../store/selectors/paymentsSelectors';

// overlay oscuro
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  /* evita scroll del fondo */
  overflow: hidden;
`;

// contenedor principal
const ModalContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 0 18px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// imagen centrada
const ImageWrapper = styled.div`
  width: 100%;
  img {
    width: 100%;
    height: 454px;
    border-radius: 16px;
    display: block;
  }
`;

// botón cerrar
const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 32px;
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #0071d1;
  font-size: 14px;
  font-weight: 900;
  cursor: pointer;
  /* mejor UX en mobile */
  padding: 4px 8px;
  border-radius: 100px;
  background: #fff;
  width: 80px;
  height: 32px;
`;

// icono
const CloseIcon = styled.span`
  font-size: 16px;
  margin-top: -2px
`;

class ModalInApp extends Component {
   constructor(props) {
    super(props);
    this.state = {
      showMsgModalInApp : false
    };
  }

  componentDidMount() {
    const { canShowModalInApp, isAnonimous, isContainerTelcel } = this.props
    const now = Date.now();
    console.log(canShowModalInApp, "En el in app canShowModalInApp");
    console.log(isContainerTelcel, "En el in app isContainerTelcel");
    // ✅ si no trae configuración de mostrar modal in-app o viene en false, o no es contenedor, no lo muetsra.
    if(!isContainerTelcel || !canShowModalInApp ) return null;

    // 👉 claves dinámicas para mostrar una solo vez por app
    const lastAnonymousSeenKey = `modal_seen_session`;
    const lastSeenKey = `modal_last_seen`;
    console.log(isAnonimous, "En el in app isAnonimous");
    console.log(lastAnonymousSeenKey, "En el in app lastAnonymousSeenKey");
    console.log(lastSeenKey, "En el in app lastSeenKey");

    if (isAnonimous) {
      // ✅ Usuario no logueado → usar sessionStorage
      const seenAnonymous = localStorage.getItem(lastAnonymousSeenKey);
      console.log(this.parseDate(Number(seenAnonymous)), "lastAnonymousSeen");
      if (!seenAnonymous || now - Number(seenAnonymous) > TIMER_SHOW_MSG_MODAL_IN_APP_ANONYMOUS_USERS) {
        this.setState({showMsgModalInApp: true})
        localStorage.setItem(lastAnonymousSeenKey, now.toString());
      }
    } else {
      // ✅ Usuario logueado → usar localStorage
      const lastSeen = localStorage.getItem(lastSeenKey);
      console.log(this.parseDate(Number(lastSeen)), "lastSeen");
      if (!lastSeen || now - Number(lastSeen) > TIMER_SHOW_MSG_MODAL_IN_APP_LOGGED_USERS) {
        this.setState({showMsgModalInApp: true})
        localStorage.setItem(lastSeenKey, now.toString());
      }
    }
  };

  parseDate = (dateEpoc) =>{
    const date = new Date(dateEpoc);
    return(date.toLocaleString())
  }

  handleOnCloseModalInApp = () => {
    this.setState({showMsgModalInApp: false})
  }

  validCategoryPlansId = (categoryPlansId) =>{
    return IN_APP_VALID_CATEGORY_IDS.includes(categoryPlansId)
  }

  render() {
    const { showMsgModalInApp } = this.state;
    const {REACT_APP_IMG_MSG_MODAL_IN_APP}  = process.env;

    if (!showMsgModalInApp) return null;

    return (
      <Overlay>
        <ModalContainer>
          {/* Botón cerrar */}
          <CloseButton onClick={this.handleOnCloseModalInApp}>
            Cerrar
            <CloseIcon>✕</CloseIcon>
          </CloseButton>

          {/* Imagen */}
          <ImageWrapper>
            <img src={REACT_APP_IMG_MSG_MODAL_IN_APP} alt="modal" />
          </ImageWrapper>
        </ModalContainer>
      </Overlay>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAnonimous: state.payments.isAnonimous,
    isContainerTelcel : isContainerTelcelSelector(state)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {},
    dispatch
  );
}

ModalInApp = connect(mapStateToProps, mapDispatchToProps)(ModalInApp);

export default ModalInApp;

